import { render, staticRenderFns } from "./ho-una-card.vue?vue&type=template&id=fdef18c6"
import script from "./ho-una-card.vue?vue&type=script&lang=js"
export * from "./ho-una-card.vue?vue&type=script&lang=js"
import style0 from "./ho-una-card.vue?vue&type=style&index=0&id=fdef18c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports